import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule }  from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { ManageCalendariComponent } from './manage-calendar.component';

import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    TranslateModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    ManageCalendariComponent,
  ],
  exports: [
    ManageCalendariComponent,
  ]
})
export class ManageCalendarModule { }
